import {KecPath, Service, Version, source} from './constants';

export const DescribeLocalVolumeSnapshots = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeLocalVolumeSnapshots',
        Service,
        Version,
        source
    }
};

export const DeleteSnaps = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DeleteLocalVolumeSnapshot',
        Service,
        Version,
        source
    }
};

export const rollbackSnaps = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'RollbackLocalVolume',
        Service,
        Version,
        source
    }
};

export const ModifyLocalVolumeSnapshot = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ModifyLocalVolumeSnapshot',
        Service,
        Version,
        source
    }
};
export const DescribeSnapshotUsageHistory = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'DescribeSnapshotUsageHistory',
        Service,
        Version,
        source
    }
};
export const DescribeSnapshotChains = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'DescribeSnapshotChains',
        Service,
        Version,
        source
    }
};
export const DescribeSnapshotsOfChain = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'DescribeSnapshotsOfChain',
        Service,
        Version,
        source
    }
};
export const DescribeSnapshotChainTotalSize = {
    method: 'get',
    basePath: KecPath,
    params: {
        Action: 'DescribeSnapshotChainTotalSize',
        Service,
        Version,
        source
    }
};
export const DescribeSnapshots = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'DescribeSnapshots',
        Service,
        Version,
        source
    }
};
export const CopySnapshot = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'CopySnapshot',
        Service,
        Version,
        source
    }
};
export const ModifySnapshotScheduledTime = {
    method: 'post',
    basePath: KecPath,
    params: {
        Action: 'ModifySnapshotScheduledTime',
        Service,
        Version,
        source
    }
};
